import { render, staticRenderFns } from "./ResultRegular.vue?vue&type=template&id=e58bd8a8"
import script from "./ResultRegular.vue?vue&type=script&lang=js"
export * from "./ResultRegular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports